import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const TagIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    {/* Tag shape */}
    <Path d="M1 10.8387V1H10.8387L23 13.1613L13.1613 23L1 10.8387Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    {/* Tag hole (diamond) */}
    <Path d="M5.28 6.69L6.69 5.28L5.28 3.87L3.87 5.28L5.28 6.69Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </Svg>
);

TagIcon.displayName = 'TagIcon';
